import { Component } from '@angular/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-slots-popup',
    templateUrl: './slots-popup.component.html',
    styleUrls: ['./slots-popup.component.scss'],
    standalone: false
})
export class SlotsPopupComponent {
  constructor(private modalRef: ModalOverlayRef) {
    this.modalRef.backgroundClicked();
  }

  public close(result: boolean) {
    this.modalRef.close(result);
  }
}
